export default "__VITE_ASSET__BSzs6XDi__"